import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AppInterceptor } from './modules/core/http/http.interceptor';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { AutosizeModule } from 'ngx-autosize';
import { AgmCoreModule } from '@agm/core';
import { environment } from 'src/environments/environment';

export const MY_DATE_FORMATS = {
	parse: {
		dateInput: 'DD/MM/YYYY',
	},
	display: {
		dateInput: 'DD/MM/YYYY',
		monthYearLabel: 'MMMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY',
	},
};
@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		HttpClientModule,
		ModalModule.forRoot(),
		ProgressSpinnerModule,
		ToastModule,
		AutosizeModule,
		AgmCoreModule.forRoot({
			apiKey: environment.googlApi,
			libraries: ['places'],
		}),
	],
	providers: [
		MessageService,
		{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
		{ provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
